import { APP_CONSTANTS } from 'utils/constants'
import { timezoneDate } from 'utils/helpers'

export const fromReportGridExtended = data => {
  const res = []
  for (let i = 0; i < data.length; i++) {
    if (data[i].proposals.length) {
      for (let j = 0; j < data[i].proposals.length; j++) {
        res.push({
          dueDate: (data[i].dueDate && timezoneDate(data[i].dueDate)) || '',
          name: data[i].name || '',
          briefNote: data[i].briefNote || '',
          newBidReview: data[i].internalBidStatus || '',
          biddingAwarded: (data[i].bidStatus && data[i].bidStatus.name) || '',
          companyName: data[i].proposals[j].companyName || '',
          status:
            (data[i].proposals[j].status &&
              APP_CONSTANTS.ProposalStatus[data[i].proposals[j].status]) ||
            '',
          followUpDate:
            (data[i].proposals[j].followUpDate &&
              timezoneDate(data[i].proposals[j].followUpDate)) ||
            '',
          sentTo:
            ((data[i].proposals[j].sentTo && data[i].proposals[j].sentTo.firstName) || '') +
            ' ' +
            ((data[i].proposals[j].sentTo && data[i].proposals[j].sentTo.lastName) || ''),
          mainContact:
            ((data[i].proposals[j].mainContact && data[i].proposals[j].mainContact.firstName) ||
              '') +
            ' ' +
            ((data[i].proposals[j].mainContact && data[i].proposals[j].mainContact.lastName) || ''),
          mainContactPhone:
            (data[i].proposals[j].mainContact && data[i].proposals[j].mainContact.phone) || '',
          mainContactEmail:
            (data[i].proposals[j].mainContact && data[i].proposals[j].mainContact.email) || '',
          dealManager: (data[i].dealManager && data[i].dealManager.userName) || '',
          dealCategory: (data[i].dealCategory && data[i].dealCategory.name) || '',
          dealSize: (data[i].size && APP_CONSTANTS.DealSize[data[i].size]) || '',
          value: data[i].value || '',
          dealStatus: (data[i].status && data[i].status.name) || '',
          cost: data[i].cost || '',
          quoteNumber: data[i].quoteNumber || '',
          projectNumber: data[i].projectNumber || '',
          margin: data[i].margin || '',
          profit: data[i].profit || '',
          awardedCompany: data[i].awardedCompany?.name ?? '',
          closeDate: (data[i].expectedCloseDate && timezoneDate(data[i].expectedCloseDate)) || '',
          wonDate: (data[i].wonDate && timezoneDate(data[i].wonDate)) || ''
        })
      }
    } else {
      res.push({
        dueDate: (data[i].dueDate && timezoneDate(data[i].dueDate)) || '',
        name: data[i].name || '',
        briefNote: data[i].briefNote || '',
        newBidReview: (data[i].bidStatus && data[i].bidStatus.name) || '',
        biddingAwarded: (data[i].bidStatus && data[i].bidStatus.name) || '',
        dealManager: (data[i].dealManager && data[i].dealManager.userName) || '',
        dealCategory: (data[i].dealCategory && data[i].dealCategory.name) || '',
        dealSize: (data[i].size && APP_CONSTANTS.DealSize[data[i].size]) || '',
        value: data[i].value || '',
        dealStatus: (data[i].status && data[i].status.name) || '',
        cost: data[i].cost || '',
        margin: data[i].margin || '',
        profit: data[i].profit || '',
        awardedCompany: data[i].awardedCompany?.name ?? '',
        closeDate: (data[i].expectedCloseDate && timezoneDate(data[i].expectedCloseDate)) || '',
        wonDate: (data[i].wonDate && timezoneDate(data[i].wonDate)) || ''
      })
    }
  }
  return res
}
